export enum SearchBarMode {
    SIMPLE = 'simple',
    ADVANCED = 'advanced',
    ALL_SEARCH_OPTIONS = 'allSearchOptions',
    FIELD = 'field',
    NONE = 'none'
}
